module.exports = __webpack_public_path__ + "assets/img/hero-illusrtation.41c9abdd.png";